import React from "react";
import Grade12ScienceMenu from "./Grade12ScienceMenu";

export default function Grade11ScienceLesson() {
  return <Grade12ScienceMenu />;
}